// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgVolcano = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.233 4.232a2.5 2.5 0 0 1 3.535 0c.501.501.68.734.741 1.133a.75.75 0 0 0 1.271.415c.258-.257.647-.39 1.092-.361.449.029.889.22 1.189.52a1.5 1.5 0 0 1 0 2.122.75.75 0 1 0 1.06 1.06 3 3 0 0 0 0-4.242 3.378 3.378 0 0 0-2.152-.957 3.105 3.105 0 0 0-1.341.203c-.222-.368-.51-.664-.8-.953a4 4 0 0 0-5.656 0c-.29.29-.578.585-.8.953a3.105 3.105 0 0 0-1.34-.203 3.377 3.377 0 0 0-2.153.956 3 3 0 0 0 0 4.243.75.75 0 0 0 1.06-1.06 1.5 1.5 0 0 1 0-2.122c.3-.3.74-.491 1.189-.52.446-.029.834.104 1.092.361a.75.75 0 0 0 1.271-.415c.062-.399.24-.632.742-1.133ZM9.5 7.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 1 0 1.5 0v-.5ZM11.252 7a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 .75-.75ZM8.75 10a.75.75 0 0 0-.716.53c-.956 3.106-2.36 4.575-3.442 5.279a4.552 4.552 0 0 1-1.367.612 2.948 2.948 0 0 1-.469.078l-.013.001A.75.75 0 0 0 2.75 18v-.75c0 .75.001.75.002.75H2.78a1.976 1.976 0 0 0 .229-.017c.143-.017.34-.047.579-.107a6.048 6.048 0 0 0 1.82-.81c1.342-.872 2.844-2.515 3.887-5.566h1.41c1.041 3.051 2.543 4.694 3.886 5.566.702.457 1.343.69 1.82.81a4.436 4.436 0 0 0 .753.121l.054.003h.03s.002 0 .002-.75V18a.75.75 0 0 0 .007-1.5h-.013a2.95 2.95 0 0 1-.469-.079 4.552 4.552 0 0 1-1.367-.612c-1.082-.704-2.486-2.173-3.442-5.28a.75.75 0 0 0-.716-.529h-2.5Z"
    />
  </svg>
)

export default SvgVolcano
